module.exports = __webpack_public_path__ + "static/media/福利全景图@2x.ce054bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/福利全景图@2x.png
// module id = 1539
// module chunks = 0